import { ChangeDetectionStrategy, Component, OnDestroy } from '@angular/core';

import { BaryModalForm } from '../../../../../../../../models/bary-modal-form';
import { BaryComponentHelper } from '../../../../../../util/bary-component-helper';
import { IBaryModalEvent } from '../../../../../../../../models/bary-modal-event';
import { MDBModalRef } from 'ng-uikit-pro-standard';

@Component({
  templateUrl: './popin-evt-transport.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PopinEvtTransportComponent extends BaryModalForm implements OnDestroy {
  public override action = BaryComponentHelper.generateAction<IBaryModalEvent>();
  public messages!: string[];

  constructor(public modalRef: MDBModalRef) {
    super();
  }

  public handleClick(event: IBaryModalEvent): void {
    this.action.next(event);
    this.modalRef.hide();
  }

  public override handleSubmit(event: IBaryModalEvent): void {
    this.action.next(event);
    this.modalRef.hide();
  }
}
